import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';

import * as actions from '../actions/search';
import { sketchDefaultData } from '@modules/sketch/pages/create/constants';

const initialState = fromJS({
  config: { data: [], state: null },
  codes: { data: {}, state: null },
  resultsConfig: { data: [], state: null },
  results: { data: [], state: null },
  sketchData: {
    state: 'null',
    modifier: {},
    data: JSON.parse(JSON.stringify(sketchDefaultData)),
  },
  sketchSettings: {
    state: 'fetching',
    data: {
      autoZoom: true,
      precision: 0.5,
      textSettings: {
        labelColor: '#000000',
        labelSize: 13,
        annotationColor: '#000000',
        annotationSize: 13,
        dimensionColor: '#000000',
        dimensionSize: 13,
      },
    },
  },
  editSketch: {
    state: 'fetching',
    data: {
      ...JSON.parse(JSON.stringify(sketchDefaultData)),
      table: [
        {
          improvementDetail: 'N/A',
          area: 0,
          perimeter: 0,
          nodes: 0,
          arcs: 0,
        },
      ],
    },
  },
  comments: {
    state: null,
    data: [],
  },
  tags: {
    state: null,
    data: [],
  },
  appraisalData: {
    state: null,
    data: [],
  },
  sketchQuery: {
    state: null,
    data: {},
  },
});

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_IMPROVEMENTS_SUCCESS: {
      return state
        .setIn(['appraisalData', 'state'], fetchingState.LOADED)
        .setIn(['appraisalData', 'data'], action.data.results);
    }
    case actions.SKETCH_QUERY_SUCCESS: {
      return state
        .setIn(['sketchQuery', 'state'], fetchingState.LOADED)
        .setIn(['sketchQuery', 'data'], action.data);
    }
    case actions.GET_TAGS_SUCCESS: {
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
    }
    case actions.POST_TAG_SUCCESS: {
      // console.log('post tag');
      // console.log(action);
      // console.log(action.payload.tag);
      // let newNotes = state.getIn([ 'tags', 'data' ]).toJS();
      // newNotes = newNotes.concat(action.data.results);
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.DELETE_TAG_SUCCESS: {
      // let newNotes = state.getIn([ 'comments', 'data' ]).toJS();
      // newNotes = newNotes.concat(action.data.results);
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.GET_COMMENTS_SUCCESS: {
      return state
        .setIn(['comments', 'state'], fetchingState.LOADED)
        .setIn(['comments', 'data'], fromJS(action.data.results));
    }
    case actions.EDIT_COMMENT_SUCCESS: {
      let newNotes = state.getIn(['comments', 'data']).toJS();
      for (let x = 0; x < newNotes.length; x++) {
        if (newNotes[x].commentID === action.data.results[0].commentID) {
          newNotes[x].content = action.data.results[0].content;
        }
      }
      return state
        .setIn(['comments', 'state'], fetchingState.LOADED)
        .setIn(['comments', 'data'], fromJS(newNotes));
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.POST_COMMENT_SUCCESS: {
      let newNotes = state.getIn(['comments', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state
        .setIn(['comments', 'state'], fetchingState.LOADED)
        .setIn(['comments', 'data'], fromJS(newNotes));
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.DELETE_COMMENT_SUCCESS: {
      return state.setIn(['comments', 'state'], fetchingState.LOADED).setIn(
        ['comments', 'data'],
        fromJS(
          state
            .get('comments')
            .toJS()
            .data.filter(note => note.commentID !== action.payload),
        ),
      );
      // return state
      //   .setIn([ 'comments', 'state' ], fetchingState.LOADED)
      //   .setIn([ 'comments', 'data' ], fromJS(action.data.results));
    }
    case actions.DELETE_SKETCH_SUCCESS: {
      return state.setIn(['results', 'state'], fetchingState.LOADED).setIn(
        ['results', 'data'],
        fromJS(
          state
            .get('results')
            .toJS()
            .data.filter(record => record.sketchID !== action.payload),
        ),
      );
    }
    case actions.EDIT_SKETCH_SUCCESS: {
      let defaultData = JSON.parse(JSON.stringify(sketchDefaultData));
      const result = action.data ? action.data.results[0] : defaultData;
      result.table = [];
      for (let x = 1; x <= result.sketchCommands[2].detailList.length; x++) {
        let nodes = 0;
        let area = 0;
        const improvementDetail = result.sketchCommands[2].detailList[x - 1];
        let arcs = 0;
        let perimeter = 0;
        const newRow = {};
        for (let y = 0; y < result.sketchCommands[0].details.length; y++) {
          if (result.sketchCommands[0].details[y].detailInfo === x) {
            if (result.sketchCommands[0].details[y].area) {
              if (result.sketchCommands[0].details[y].type === 'xgon') {
                nodes += result.sketchCommands[0].details[y].numSides;
              } else if (
                result.sketchCommands[0].details[y].type !== 'circle'
              ) {
                nodes =
                  nodes +
                  result.sketchCommands[0].details[y].coordinates.length -
                  1;
              }
            } else {
              nodes += result.sketchCommands[0].details[y].coordinates.length;
            }
            area += result.sketchCommands[0].details[y].area;
            perimeter += result.sketchCommands[0].details[y].perimeter;
            for (
              let z = 0;
              z < result.sketchCommands[0].details[y].arcData.length;
              z++
            ) {
              if (result.sketchCommands[0].details[y].arcData[z]) {
                arcs++;
              }
            }
          }
        }
        newRow.improvementDetail = improvementDetail;
        newRow.area = (area / 100).toFixed(1);
        newRow.perimeter = (perimeter / 10).toFixed(1);
        newRow.nodes = nodes;
        newRow.arcs = arcs;
        if (!(area === 0 && perimeter === 0 && nodes === 0 && arcs === 0)) {
          result.table.push(newRow);
        }
      }
      if (result.table.length === 0) {
        result.table = [
          {
            improvementDetail: 'N/A',
            area: 0,
            perimeter: 0,
            nodes: 0,
            arcs: 0,
          },
        ];
      }
      return state
        .setIn(['editSketch', 'state'], fetchingState.LOADED)
        .setIn(['editSketch', 'data'], fromJS(result));
    }
    case actions.FETCH_SKETCH_SETTINGS_SUCCESS: {
      const settings = {};
      if (!action.data || !action.data.results[0].settings.precision) {
        settings.precision = 0.5;
      } else {
        settings.precision = action.data.results[0].settings.precision;
      }
      if (
        action.data &&
        action.data.results &&
        action.data.results[0] &&
        action.data.results[0].settings &&
        action.data.results[0].settings.autoZoom
      ) {
        settings.autoZoom = true;
      } else {
        settings.autoZoom = false;
      }
      if (!action.data || !action.data.results[0].settings.textSettings) {
        settings.textSettings = {
          labelColor: '#000000',
          labelSize: 13,
          annotationColor: '#000000',
          annotationSize: 13,
          dimensionColor: '#000000',
          dimensionSize: 13,
        };
      } else {
        settings.textSettings = action.data.results[0].settings.textSettings;
        settings.showClass = action.data.results[0].settings.showClass;
      }
      settings.updateDt = action.data ? action.data.results[0].updateDt : null;
      return state
        .setIn(['sketchSettings', 'state'], fetchingState.LOADED)
        .setIn(['sketchSettings', 'data'], fromJS(settings));
      // .setIn([ 'sketchSettings', 'data' ], fromJS(action.data.results[0].settings));
    }
    case actions.FETCH_SEARCH_CONFIG_SUCCESS: {
      return state
        .setIn(['config', 'state'], fetchingState.LOADED)
        .setIn(['config', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_SUCCESS: {
      return state
        .setIn(['resultsConfig', 'state'], fetchingState.LOADED)
        .setIn(['resultsConfig', 'data'], fromJS(action.data.results));
    }
    case actions.SAVE_SKETCH_SUCCESS: {
      let newSketchData = state.getIn(['sketchData', 'data']).toJS();
      if (action.data && action.data.results && action.data.results[0]) {
        newSketchData.updateDt = action.data.results[0].updateDt;
        newSketchData.updatedBy = action.data.results[0].updatedBy;
        newSketchData.createDt = action.data.results[0].createDt;
        newSketchData.createdBy = action.data.results[0].createdBy;
        newSketchData.sketchID = action.data.results[0].sketchID;
        newSketchData.sketchCommands = action.data.results[0].sketchCommands;
      }
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['sketchData', 'data'], fromJS(newSketchData));
    }
    case actions.SAVE_APPRAISAL_SKETCH_SUCCESS: {
      let newSketchData = state.getIn(['sketchData', 'data']).toJS();
      if (
        action.data.body &&
        action.data.body.results &&
        action.data.body.results[0]
      ) {
        newSketchData.updateDt = action.data.body.results[0].updateDt;
        newSketchData.updatedBy = action.data.body.results[0].updatedBy;
        newSketchData.createDt = action.data.body.results[0].createDt;
        newSketchData.createdBy = action.data.body.results[0].createdBy;
        newSketchData.sketchID = action.data.body.results[0].sketchID;
        newSketchData.sketchCommands =
          action.data.body.results[0].sketchCommands;
        newSketchData.improvementID = action.data.body.results[0].improvementID;
      }
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['sketchData', 'data'], fromJS(newSketchData));
    }
    case actions.SET_SKETCH_SETTINGS_SUCCESS: {
      const settings = action.data.results[0].settings;
      settings.updateDt = action.data.results[0].updateDt;
      return state
        .setIn(['sketchSettings', 'state'], fetchingState.LOADED)
        .setIn(['sketchSettings', 'data'], fromJS(settings));
    }
    case actions.UPDATE_SKETCH_SUCCESS: {
      let newSketchData = state.getIn(['sketchData', 'data']).toJS();
      if (action.data && action.data.results && action.data.results[0]) {
        newSketchData.updateDt = action.data.results[0].updateDt;
        newSketchData.updatedBy = action.data.results[0].updatedBy;
        newSketchData.createDt = action.data.results[0].createDt;
        newSketchData.createdBy = action.data.results[0].createdBy;
        newSketchData.sketchID = action.data.results[0].sketchID;
        newSketchData.sketchCommands = action.data.results[0].sketchCommands;
      }
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['sketchData', 'data'], fromJS(newSketchData));
    }
    case actions.UPDATE_APPRAISAL_SKETCH_SUCCESS: {
      let newSketchData = state.getIn(['sketchData', 'data']).toJS();
      if (
        action.data.body &&
        action.data.body.results &&
        action.data.body.results[0]
      ) {
        newSketchData.updateDt = action.data.body.results[0].updateDt;
        newSketchData.updatedBy = action.data.body.results[0].updatedBy;
        newSketchData.createDt = action.data.body.results[0].createDt;
        newSketchData.createdBy = action.data.body.results[0].createdBy;
        newSketchData.sketchID = action.data.body.results[0].sketchID;
        newSketchData.sketchCommands =
          action.data.body.results[0].sketchCommands;
        newSketchData.improvementID = action.data.body.results[0].improvementID;
      }
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['sketchData', 'data'], fromJS(newSketchData));
    }
    case actions.SEARCH_SUCCESS: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.SET_INITIAL_SKETCH_DATA_SUCCESS: {
      return state
        .setIn(['sketchData', 'state'], fetchingState.LOADED)
        .setIn(['sketchData', 'data'], fromJS(action.data.results[0]));
    }
    case actions.SET_INITIAL_SKETCH_MODIFIER: {
      return state.setIn(['sketchData', 'modifier'], fromJS(action.sketchData));
    }
    case actions.GET_IMPROVEMENTS_START: {
      return state.setIn(['appraisalData', 'state'], fetchingState.FETCHING);
    }
    case actions.SKETCH_QUERY_START: {
      return state.setIn(['sketchQuery', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_TAGS_START: {
      return state.setIn(['tags', 'state'], fetchingState.FETCHING);
    }
    case actions.POST_TAG_START: {
      return state.setIn(['tags', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_COMMENTS_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.EDIT_COMMENT_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.POST_COMMENT_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_COMMENT_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_SKETCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.EDIT_SKETCH_START: {
      return state.setIn(['editSketch', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SKETCH_SETTINGS_START: {
      return state.setIn(['sketchSettings', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_CONFIG_START: {
      return state.setIn(['config', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_START: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.FETCHING);
    }
    case actions.SAVE_SKETCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.SAVE_APPRAISAL_SKETCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.SET_SKETCH_SETTINGS_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_SKETCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_APPRAISAL_SKETCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.SEARCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.SET_INITIAL_SKETCH_DATA_START: {
      return state.setIn(['sketchData', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_IMPROVEMENTS_ERROR: {
      return state.setIn(['appraisalData', 'state'], fetchingState.ERROR);
    }
    case actions.SKETCH_QUERY_ERROR: {
      return state
        .setIn(['sketchQuery', 'state'], fetchingState.ERROR)
        .setIn(['sketchQuery', 'data'], {});
    }
    case actions.GET_TAGS_ERROR: {
      return state.setIn(['tags', 'state'], fetchingState.ERROR);
    }
    case actions.POST_TAG_ERROR: {
      return state.setIn(['tags', 'state'], fetchingState.ERROR);
    }
    case actions.GET_COMMENTS_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.EDIT_COMMENT_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.POST_COMMENT_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_COMMENT_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_SKETCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.EDIT_SKETCH_ERROR: {
      return state.setIn(['editSketch', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SKETCH_SETTINGS_ERROR: {
      const settings = {
        autoZoom: true,
        precision: 0.5,
        textSettings: {
          labelColor: '#000000',
          labelSize: 13,
          annotationColor: '#000000',
          annotationSize: 13,
          dimensionColor: '#000000',
          dimensionSize: 13,
        },
      };
      return state
        .setIn(['sketchSettings', 'state'], fetchingState.LOADED)
        .setIn(['sketchSettings', 'data'], fromJS(settings));
      // return state.setIn([ 'sketchSettings', 'state' ], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_CONFIG_ERROR: {
      return state.setIn(['config', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_ERROR: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.ERROR);
    }
    case actions.SAVE_SKETCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.SAVE_APPRAISAL_SKETCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.SET_SKETCH_SETTINGS_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_SKETCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_APPRAISAL_SKETCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.SEARCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.SET_INITIAL_SKETCH_DATA_ERROR: {
      return state.setIn(['sketchData', 'state'], fetchingState.ERROR);
    }
    default: {
      return state;
    }
  }
};

export default SearchReducer;
